import React, { useCallback } from 'react'
import styled from 'styled-components'

import Switch from 'components/Switch'
import Icon from 'components/Icon'
import { OPTION_NAME_LENGTH } from 'constants/ReceptionCustom'
import { Input } from 'containers/Reception/components/utils'
import { CheckoutAdditionalFieldOption } from '../types'

const CustomButton = styled.button`
  background: none;
  border: none;
  outline: none !important;
`

type Props = {
  option: CheckoutAdditionalFieldOption
  index: number
  canUpdate: boolean
  onChangeVisibility: (index: number) => void
  onChangeOptionName: (value: string, shouldDisplay: boolean, index: number) => void
  onRemove: (index: number) => void
}

const CheckoutAdditionalFieldEditorRow: React.FC<Props> = ({
  option,
  index,
  canUpdate,
  onChangeVisibility,
  onChangeOptionName,
  onRemove,
}) => {
  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
      const shouldDisplay = Boolean(value.length)
      onChangeOptionName(value, shouldDisplay, index)
    },
    [index, onChangeOptionName]
  )

  const handleVisibilityChange = useCallback(() => {
    onChangeVisibility(index)
  }, [index, onChangeVisibility])

  const handleRemove = useCallback(() => {
    onRemove(index)
  }, [index, onRemove])

  const shouldShowRemoveButton = canUpdate && Boolean(option.optionName)

  return (
    <div className="d-flex mb-1 align-items-center" style={{ height: 40 }}>
      <Switch
        checked={option.displayFlag}
        onChange={handleVisibilityChange}
        className="mr-3"
        disabled={!canUpdate}
      />
      <Input
        type="text"
        value={option.optionName || ''}
        maxLength={OPTION_NAME_LENGTH}
        style={{ width: 360 }}
        onChange={handleNameChange}
        disabled={!canUpdate}
      />
      {shouldShowRemoveButton && (
        <CustomButton onClick={handleRemove}>
          <Icon width={''} height={''} src="/assets/svgs/circle-minus.svg" />
        </CustomButton>
      )}
    </div>
  )
}

export default React.memo(CheckoutAdditionalFieldEditorRow)
